'use client';

import styled from '@benzinga/themetron';

export const ModalCoverScreen = styled.div`
  height: 90vh;
  width: 80vw;
`;

export const ModalBackground = styled.div`
  align-items: center;
  background: rgba(${props => props.theme.colors.backgroundActive}, 0.5);
  bottom: 0;
  flex-direction: column;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  top: 0;
  z-index: 1;
`;

export const ModalContent = styled.div`
  display: flex;
  padding: 1em;
  flex-grow: 1;
  flex-direction: column;
  min-height: 1px;
`;
export const ModalClose = styled.div`
  font-size: 1.5em;
  svg {
    fill: ${props => props.theme.colors.foregroundInactive};
  }
`;

export const ModalInput = styled.input`
  border-color: ${props => props.theme.colors.backgroundInactive};
`;

export const ModalTitle = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.backgroundInactive};
  color: ${props => props.theme.colors.foreground};
  font-weight: 300;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  padding-bottom: 0.5em;
  text-transform: uppercase;
  :first-child {
    margin-top: 0;
  }
`;

export const ModalSubtitle = styled.div`
  margin-top: -1em;
  margin-bottom: 1em;
  line-height: 16px;
`;

export const ModalLabel = styled.div`
  color: ${props => props.theme.colors.foregroundInactive};
  display: inline-block;
  font-size: 0.75em;
  margin-bottom: 0.75em;
  text-transform: uppercase;
`;

export const ModalLabelWarning = styled.div`
  color: ${props => props.theme.colors.warning};
`;

export const ModalOption = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1em;
  flex-shrink: 0;
`;

export const ModalOptionText = styled.div`
  padding: 0 0.5em;
`;
